import { render, staticRenderFns } from "./FindId.vue?vue&type=template&id=1edf63a4"
import script from "./FindId.vue?vue&type=script&lang=js"
export * from "./FindId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports